import React from "react";

const FieldSelector = ({ selectedType, setSelectedType, addField, fieldTypes }) => {
  return (
    <div className="flex gap-2 mb-4 items-center justify-center">
      <select
        value={selectedType}
        onChange={(e) => setSelectedType(e.target.value)}
        className="border p-2 rounded"
      >
        <option value="">-- Select Field --</option>
        {fieldTypes.map((f) => (
          <option key={f.type} value={f.type}>
            {f.label}
          </option>
        ))}
      </select>

      <button onClick={addField} className="bg-blue-500 text-white px-4 py-2 rounded">
        Add
      </button>
    </div>
  );
};

export default FieldSelector;
